import React from 'react';
import {useTranslation} from 'react-i18next';
import {Lock} from '../../icons';

const RAW = {interpolation: {escapeValue: false}};
const TIP_ID = 'agp-privacy-tip';

/**
 * Quién ve los prompts, al lado del título. Antes era una franja entera debajo de las solapas: el texto
 * tranquiliza pero no pide nada, y con ese peso se leía como una advertencia. El detalle completo va en
 * el `warning-tooltip` del sistema, que abre con el mouse y con el foco (Tab).
 */
export function PrivacyChip({agencyName}) {
    const {t} = useTranslation();
    return (
        <span className="info-icon-container agp-lock">
            <button type="button" className="agp-lock__chip" aria-describedby={TIP_ID}>
                <Lock size={13} weight="bold" aria-hidden="true"/>
                {t('agency_prompts.privacy_chip')}
            </button>
            <span className="warning-tooltip -below-left -rich" role="tooltip" id={TIP_ID}>
                <span className="warning-tooltip-body">
                    <span className="warning-tooltip-text">
                        <strong>{t('agency_prompts.privacy_lead', {agency: agencyName, ...RAW})}</strong>
                        {' '}{t('agency_prompts.privacy_body')}
                    </span>
                </span>
            </span>
        </span>
    );
}
